"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyTimeslotsToPricingPolicies = legacyTimeslotsToPricingPolicies;
const TDR_1 = require("../types/TDR");
const time_1 = require("./time");
const has_1 = __importDefault(require("lodash/has"));
const flatMap_1 = __importDefault(require("lodash/flatMap"));
const toPairs_1 = __importDefault(require("lodash/toPairs"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const filter_1 = __importDefault(require("lodash/filter"));
function overrideToCondition(override) {
    const { targetIds, targetTags } = override;
    const targetClauses = (targetIds || []).map(id => ({
        itemType: TDR_1.TDR.Reservation.ItemType.Table,
        itemId: id
    }));
    if (!(0, isEmpty_1.default)(targetTags)) {
        targetClauses.push({ tag: targetTags });
    }
    const targetCondition = (targetClauses.length === 0 ? {} :
        targetClauses.length === 1 ? targetClauses[0] :
            { or: targetClauses });
    const { dates, weekdays, minGuests, maxGuests } = override.conditions || {};
    const dateTimeClauses = [];
    if (!(0, isEmpty_1.default)(weekdays)) {
        dateTimeClauses.push({ daysOfWeek: weekdays.map(time_1.normalizeWeekday) });
    }
    if (!(0, isEmpty_1.default)(dates)) {
        dateTimeClauses.push({ dates: dates });
    }
    const dateTimeCondition = (dateTimeClauses.length === 0 ? {} :
        dateTimeClauses.length === 1 ? dateTimeClauses[0] :
            { or: dateTimeClauses });
    // Gate by guest-size if the override has minGuests/maxGuests conditions.
    const guestCondition = {};
    if (minGuests !== undefined || maxGuests !== undefined) {
        guestCondition.betweenGuests = [minGuests !== null && minGuests !== void 0 ? minGuests : 1, maxGuests !== null && maxGuests !== void 0 ? maxGuests : Number.MAX_SAFE_INTEGER];
    }
    if (targetClauses.length < 2 || dateTimeClauses.length < 2) {
        return Object.assign(Object.assign(Object.assign({}, targetCondition), dateTimeCondition), guestCondition);
    }
    return Object.assign({ and: [
            targetCondition,
            dateTimeCondition
        ] }, guestCondition);
}
function slotToPolicy(time, slot, condition) {
    if (!(0, has_1.default)(slot, 'regularPrice')) {
        return null;
    }
    return {
        targetType: 'item',
        override: true,
        active: true,
        activeSince: null,
        condition: {
            and: [
                { betweenTimes: [time, time] },
                condition
            ]
        },
        charges: [{
                type: slot.isPerGuest ? 'per-guest' : 'add',
                label: 'Table',
                target: 'total',
                amount: slot.regularPrice
            }]
    };
}
function legacyTimeslotsToPricingPolicies(restaurant, tables) {
    const base = (0, filter_1.default)((0, flatMap_1.default)(tables, table => {
        const condition = {
            itemType: TDR_1.TDR.Reservation.ItemType.Table,
            itemId: table.id
        };
        return (0, toPairs_1.default)(table.defaultTimeSlots).map(([time, slot]) => {
            const id = `${restaurant.slug}-default-${table.slug}-${time}`;
            const policy = slotToPolicy(time, slot, condition);
            if (!policy) {
                return null;
            }
            return Object.assign(Object.assign({}, policy), { restaurantId: restaurant.id, id: id, name: id, priority: -1 });
        });
    }));
    const overrides = (0, filter_1.default)((0, flatMap_1.default)(restaurant.overrides || [], (override, index) => {
        const condition = overrideToCondition(override);
        return (0, toPairs_1.default)(override.values.defaultTimeSlots).map(([time, slot]) => {
            const id = `${restaurant.slug}-override-${override.name || index}-${time}`;
            const policy = slotToPolicy(time, slot, condition);
            if (!policy) {
                return null;
            }
            return Object.assign(Object.assign({}, policy), { restaurantId: restaurant.id, id: id, name: id, priority: 0 });
        });
    }));
    return [
        ...base,
        ...overrides
    ];
}
//# sourceMappingURL=legacyPolicies.js.map